import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatSeconds',
    standalone: false
})
export class FormatSecondsPipe implements PipeTransform {
   transform(seconds: number): string {
      return formatSeconds(seconds);
   }
}

export function formatSeconds(seconds: number): string {
   const hours = Math.floor(seconds / 3600);
   const minutes = Math.floor((seconds % 3600) / 60);
   const remainingSeconds = seconds % 60;

   return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(
      2,
      '0'
   )}`;
}
